import { StorageHistory } from "../../storages/StorageHistory"

export const OpenStorageHistory = () => {
  return (
    <StorageHistory />
  )
}
